/** Outside-mousedown decision for the hotel destination list. The opening click must not close it. */
export function shouldCloseHotelDestinationDropdown({
  suppressClose,
  locationDropdownOpen,
  mobileHotelDestOpen,
  insideLocationDropdown,
  insideLocationField,
  insideDestinationSheet,
  insideDestinationTrigger,
}) {
  if (suppressClose) {
    return { closeLocation: false, closeMobile: false };
  }

  return {
    closeLocation: Boolean(
      locationDropdownOpen
      && !mobileHotelDestOpen
      && !insideLocationDropdown
      && !insideLocationField,
    ),
    closeMobile: Boolean(
      mobileHotelDestOpen
      && !insideDestinationSheet
      && !insideDestinationTrigger,
    ),
  };
}
